export const DRAFTING_DNA_REVIEW_SECTIONS = [
  { value: 'flow_of_title', label: 'Flow of Title' },
  { value: 'documents_scrutinized', label: 'Documents Scrutinized' },
  { value: 'encumbrance_ec', label: 'Encumbrance / EC' },
  { value: 'revenue_records', label: 'Revenue Records' },
  { value: 'conditions', label: 'Conditions' },
  { value: 'certificate', label: 'Certificate' },
  { value: 'final_opinion', label: 'Final Opinion' },
];

export const getDefaultReviewSection = () => DRAFTING_DNA_REVIEW_SECTIONS[0].value;

export const normalizeDraftingDnaReviewResult = (payload = {}) => {
  const safePayload = payload || {};
  const sections = safePayload.sections || {};
  const normalizedSections = Object.fromEntries(
    DRAFTING_DNA_REVIEW_SECTIONS.map((section) => [
      section.value,
      {
        title: sections[section.value]?.title || section.label,
        result: sections[section.value]?.result || '',
      },
    ]),
  );

  return {
    profile_id: safePayload.profile_id || '',
    profile_name: safePayload.profile_name || '',
    status: safePayload.status || 'requires_recompilation',
    sections: normalizedSections,
  };
};

export const getSelectedReviewSection = (reviewResult, selectedSection) => {
  const normalized = normalizeDraftingDnaReviewResult(reviewResult);
  return normalized.sections[selectedSection] || normalized.sections[getDefaultReviewSection()];
};